// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import styled from '@emotion/styled';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import OrderProvider from 'Contexts/OrderContext';
import ViewOrder from 'Containers/Order/ViewOrder';
import { API_PRODUCTS_SEARCH } from 'Constants';

const StyledOrderPage = styled.div`
  display: block;
`;

const OrderPage = memo(() => {
  const { t } = useTranslation();
  const { bodyAttributes } = Helmet.peek() || {};

  let orderPageClassNames = bodyAttributes?.class || '';
  if (!orderPageClassNames.includes('OrderPage')) {
    orderPageClassNames += 'OrderPage';
  }

  return (
    <>
      <Helmet>
        <body className={ orderPageClassNames } />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <title>{ t('common.pages.order') }</title>
        <link
          rel="preload"
          href={ `${ API_PRODUCTS_SEARCH }?search=""&only_available=1&stock_clearing_sale=0&including_resealed=0` }
          as="fetch"
          crossOrigin="anonymous"
        />
      </Helmet>
      <OrderProvider>
        <StyledOrderPage className="grid-container">
          <ViewOrder />
        </StyledOrderPage>
      </OrderProvider>
    </>
  );
});
OrderPage.displayName = 'OrderPage';

export default OrderPage;
